import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SignaturePad } from 'angular2-signaturepad';
import { CaseUploadService } from '../case-upload.service';
import { ClientContractProfileService } from '../client-contract-profile.service';
import { ComponentDataService } from '../component-data.service';
import { ComponentService } from '../component.service';
import { PersonalDetailsDataService } from '../personal-details-data.service';
import { ClientContractPackageService } from '../client-contract-package.service';

@Component({
  selector: 'app-candidate-authorization',
  templateUrl: './candidate-authorization.component.html',
  styleUrls: ['./candidate-authorization.component.scss']
})
export class CandidateAuthorizationComponent implements OnInit {
  signaturePresent: boolean = false;

  authorize: boolean
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  signaturePadOptions = { // passed through to szimek/signature_pad constructor
    dotSize: 1.5,
    minWidth: 1.3,
    maxWidth: 1.5,
    canvasWidth: 500,
    canvasHeight: 100,
    backgroundColor: "rgb(255,255,255)",
    penColor: "rgb(0,0,0)"
  };
  disableSubmitButton: boolean = false;
  caseId: any
  case_id: any
  profile: any
  package: any
  alacart:any
  html: String
  components: any[] = []
  //tempComponents:any[]=[]
  navItems: any[] = []
  constructor(
    private componentService: ComponentService,
    private componentDataService: ComponentDataService,
    private personalDetailsDataService: PersonalDetailsDataService,
    private caseUploadService: CaseUploadService,
    private clientContractProfileService: ClientContractProfileService,
    private activatedRoute: ActivatedRoute,
    private clientContractPackageService: ClientContractPackageService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log("Access token in authorization ", this.activatedRoute.snapshot.queryParamMap.get('access_token'))

    this.getComponentDetails()

    this.clientContractProfileService.getAuthorizationform().subscribe(
      response => {
        this.html = response
      }
    )


  }
  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('minWidth', 1.3); // set szimek/signature_pad options at runtime
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    //    this.signaturePad.fromDataURL("data:image/png;base64,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")
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    console.log(this.signaturePad.toDataURL("image/jpeg"));
    this.signaturePresent = true;
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    console.log('begin drawing');
  }
  async getComponentDetails() {
    await this.getCaseDetails()
    if (this.profile != null) {
      this.components = <any[]>await this.getProfileDetails()
    } else if (this.package != null) {
      this.components = <any[]>await this.getPackageDetails()
    }else if (this.alacart != null) {
      this.components = <any[]>await this.getalacartDetails()
    }
    //    this.tempComponents = <any[]>await this.getProfileDetails()
    // this.components = <any[]>await this.getProfileDetails()
    await this.setComponentMenuItems()
    this.navItems.push({ displayName: 'Authorize & Submit', route: 'candidate/authorization', access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), children: [] })
    this.enableOrDisableSubmitButton()
  }
  /*addDisplayNameToComponents(){
    let promise = new Promise((resolve,reject)=>{
      this.tempComponents.forEach(item=>{
        this.componentService.findAComponentForCde(item.component,this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
          response=>{
            let comp = ({
              componentName : item.componentName,
              displayName :response.displayName,
              component:item.component,
              maxChecks:item.maxChecks
            })
            this.components.push(comp)
          },
          error=>{
            this.showError("Error getting display Name")
          }
        )
      })
      console.log("Components before resoving is ",this.components)
      resolve(this.components)
    })
    return promise
  } */
  getCaseDetails() {
    let promise = new Promise((resolve, reject) => {
      this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response => {
          console.log("Got reponse from cde case details")
          this.caseId = response.caseId
          this.case_id = response._id
          this.profile = response.profile
          this.package = response.package
          this.alacart = response.componentsToCheck
          console.log("alacart",this.package),
          console.log("alacart",this.alacart)
          resolve(true)
        },
        error => {
          this.showError("Error reading Case Details")
          resolve(false)
        })
    })
    return promise
  }
  getProfileDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractProfileService.getClientContractProfileDetails(this.profile + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: `candidate/candidatepersonaldetails`,
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractProfileComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              // this.globaldatabaseComponent = true
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }
          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }
  getPackageDetails() {
    let promise = new Promise((resolve, reject) => {
      this.clientContractPackageService.getClientContractPackageDetails(this.package + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        response2 => {
          console.log("Profile details are ", response2)
          this.navItems.push({
            displayName: 'Personal Details',
            route: `candidate/candidatepersonaldetails`,
            access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
            children: []
          })
          this.components = response2.clientContractPackageComponents
          this.components.forEach(item => {
            if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
              item.displayName = 'Employment'
              //              this.employmentComponent=true
            } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
              item.displayName = 'Address'
              //              this.addressComponent=true
            } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
              item.displayName = 'Education'
              //              this.educationComponent=true
            } else if (item.componentName == 'globaldatabase') {
              item.displayName = 'Global Database'
            } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
              item.displayName = 'Reference'
            } else if (item.componentName == 'criminalrecord') {
              item.displayName = 'Criminal Record'
            } else if (item.componentName == 'courtrecord') {
              item.displayName = 'Court Record'
            } else if (item.componentName == 'identity') {
              item.displayName = 'Identity'
              //              this.identityComponent=true
            } else if (item.componentName == 'gapvfn') {
              item.displayName = 'GAP'
            } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
              item.displayName = 'Drug Test'
            } else if (item.componentName == "cvanalysis") {
              item.displayName = 'CV Analysis'
            } else if (item.componentName == 'uan') {
              item.displayName = 'UAN'
            }else if (item.componentName == 'twentysixas') {
              item.displayName = 'Form 26 AS'
            }else if (item.componentName == 'credittrans') {
              item.displayName = 'Credit Check - TransUnion'
            }else if (item.componentName == 'epfo') {
              item.displayName = 'EPFO Check'
            }else if (item.componentName == 'crconline') {
              item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
            }else if (item.componentName == 'ofac') {
              item.displayName = 'OFAC Check'
            }else if (item.componentName == 'socialmedia') {
              item.displayName = 'Social Media Search'
            }else if(item.componentName == 'globalmediasearch'){
              item.displayName = 'Global Media Search'
            }else if(item.componentName == 'facisl3'){
              item.displayName = 'FACIS L3 Check'
            }

          })
          resolve(this.components)
        },
        error2 => {
          this.showError("Error reading profile details")
          resolve(null)
        }
      )
    })
    return promise
  }

    ///
    getalacartDetails() {
      let promise = new Promise((resolve, reject) => {
        this.caseUploadService.getCdeCaseDetails(this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
        // this.clientContractPackageService.getClientContractComponentsDetails(this.alacart + "?access_token=" + this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
          response2 => {
            console.log("Profile details are ", response2)
            this.navItems.push({
              displayName: 'Personal Details',
              route: 'candidate/candidatepersonaldetails',
              access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'),
              children: []
            })
            this.components = response2.componentsToCheck
            console.log("components to check",response2)
            console.log("components to check",this.components)
            this.components.forEach(item => {
              if (item.componentName == 'employment' || item.componentName == 'empbasic' || item.componentName == 'empadvance') {
                item.displayName = 'Employment'
              } else if (item.componentName == 'address' || item.componentName == 'addressonline' || item.componentName == 'addresstelephone' || item.componentName == 'addresscomprehensive') {
                item.displayName = 'Address'
              } else if (item.componentName == 'educationcomprehensive' || item.componentName == 'educationadvanced' || item.componentName == 'education') {
                item.displayName = 'Education'
              } else if (item.componentName == 'globaldatabase') {
                item.displayName = 'Global Database'
              } else if (item.componentName == 'reference' || item.componentName == 'refbasic') {
                item.displayName = 'Reference'
              } else if (item.componentName == 'criminalrecord') {
                item.displayName = 'Criminal Record'
              } else if (item.componentName == 'courtrecord') {
                item.displayName = 'Court Record'
              } else if (item.componentName == 'identity') {
                item.displayName = 'Identity'
              } else if (item.componentName == 'gapvfn') {
                item.displayName = 'GAP'
              } else if (item.componentName == 'drugtestfive' || item.componentName == 'drugtestsix' || item.componentName == 'drugtestseven' || item.componentName == 'drugtesteight' || item.componentName == 'drugtestnine' || item.componentName == 'drugtestten') {
                item.displayName = 'Drug Test'
              } else if (item.componentName == 'cvanalysis') {
                item.displayName = 'CV Analysis'
              } else if (item.componentName == 'creditcheck') {
                item.displayName = 'Credit Check'
              }  else if (item.componentName == 'uan') {
                item.displayName = 'UAN'
              }else if (item.componentName == 'twentysixas') {
                item.displayName = 'Form 26 AS'
              }else if (item.componentName == 'credittrans') {
                item.displayName = 'Credit Check - TransUnion'
              }else if (item.componentName == 'epfo') {
                item.displayName = 'EPFO Check'
              }  else if (item.componentName == 'crconline') {
                item.displayName = 'Court Record (CRC ) - Law Firm (Online)'
              }else if (item.componentName == 'ofac') {
                item.displayName = 'OFAC Check'
              }else if (item.componentName == 'socialmedia') {
                item.displayName = 'Social Media Search'
              }else if(item.componentName == 'globalmediasearch'){
                item.displayName = 'Global Media Search'
              }else if(item.componentName == 'facisl3'){
                item.displayName = 'FACIS L3 Check'
              }
  
            })
            resolve(this.components)
          },
          error2 => {
            this.showError("Error reading profile details")
            resolve(null)
          }
        )
      })
      return promise
    }
  
    ////
  // getComponentDisplayName(item) {
  //   let promise = new Promise((resolve, reject) => {
  //     this.componentService.findAComponentForCde(item.component, this.activatedRoute.snapshot.queryParamMap.get('access_token'), this.activatedRoute.snapshot.queryParamMap.get('component_serialNumber')).subscribe(
  //       response => {
  //         resolve(response.displayName)
  //       },
  //       error => {
  //         resolve("")
  //       }
  //     )
  //   })
  //   return promise
  // }
  // setComponentMenuItems() {
  //   let promise = new Promise((resolve, reject) => {
  //     this.components.forEach(item => {
  //       console.log("Item in personal details ", item)
  //       let childItems = []
  //       for (let i = 0; i < item.maxChecks; i++) {
  //         childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
  //       }
  //       this.navItems.push({ displayName: item.displayName, children: childItems })
  //       resolve(true)
  //     })
  //   })
  //   return promise
  // }
  setComponentMenuItems() {
    let promise = new Promise((resolve, reject) => {
      this.components.forEach(item => {
        console.log("Item in personal details ", item)
        let childItems = []
        for (let i = 0; i < item.maxChecks; i++) {
          childItems.push({ displayName: item.displayName + "-" + (i + 1), route: `candidate/candidatecomponentdataentry`, component_id: item.component, access_token: this.activatedRoute.snapshot.queryParamMap.get('access_token'), componentName: item.componentName, component_serialNumber: (i + 1), children: [] })
        }
        this.navItems.push({ displayName: item.displayName, children: childItems })
        resolve(true)
      })
    })
    return promise
  }

  disabled() {
    //    return this.signaturePad.isEmpty()
    if (this.signaturePad != null) {
      if (this.signaturePad.toData() == null) {
        return true
      } else {
        return false;
      }
    } else {
      return true;
    }

  }
  showError(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
  showMessage(msg) {
    this.snackBar.open(msg, 'Error', { duration: 4000, horizontalPosition: 'end', verticalPosition: 'top' })
  }
  authorizationChanged(event) {
    if (event.source.checked) {
      this.authorize = true
    } else {
      this.authorize = false
    }
  }
  saveButtonClicked() {
    if (this.signaturePresent) {
    console.log(this.signaturePad.toDataURL('image/jpeg'))
    this.caseUploadService.saveAuthorizationSignature(this.signaturePad.toDataURL('image/jpeg'), this.activatedRoute.snapshot.queryParamMap.get('access_token')).subscribe(
      response => {
        this.showMessage("Details Saved")
        this.router.navigate(['candidate/candidatedataentrycompletion'])
      },
      error => {
        this.showError("Error Saving Signature")
      }
    )
    this.showMessage("Signature present. Submitting...");
  } else {
    // Alert the user or handle the case when the signature is missing
    this.showMessage("Signature is mandatory. Please provide a signature.");
  }

  }
  clearSignatureButtonClicked() {
    this.signaturePad.clear()
    this.signaturePresent = false;
  }
  // enableOrDisableSubmitButton() {
  //   this.disableSubmitButton = false
  //   this.personalDetailsDataService.readForCde(this.case_id, null).subscribe(
  //     response => {
  //       if (response == null) {
  //         this.disableSubmitButton = true
  //       }else{
  //         this.disableSubmitButton = false

  //       }
  //     },
  //     error => {
  //       this.showError("Error reading Personal")
  //     }
  //   )
  //   if (this.disableSubmitButton == false) {
  //     for (let i = 0; i < this.components.length; i++) {
  //       this.componentDataService.findOneForCde(this.components[i].componentName, this.case_id, 1).subscribe(
  //         response => {
  //           if (response == null) {
  //             this.disableSubmitButton = true
  //           }else{
  //             this.disableSubmitButton = false

  //           }
  //         },
  //         error => {
  //           this.showError("Error reading Details")
  //         })
  //     }
  //   }
  // }

  enableOrDisableSubmitButton() {
    this.disableSubmitButton = false;
  
    this.personalDetailsDataService.readForCde(this.case_id, null).subscribe(
      response => {
        if (response == null) {
          this.disableSubmitButton = true;
        }
        // Continue with the rest of the logic
        this.checkComponents();
      },
      error => {
        this.showError("Error reading Personal");
      }
    );
  }
  
  checkComponents() {
    for (let i = 0; i < this.components.length; i++) {
      this.componentDataService.findOneForCde(this.components[i].componentName, this.case_id, 1).subscribe(
        response => {
          if (response == null) {
            this.disableSubmitButton = true;
          }
          // Continue with any additional logic if needed
        },
        error => {
          this.showError("Error reading Details");
        }
      );
    }
    // Now that all asynchronous operations are complete, you can check the button status if needed
    // For example, you can call a method to handle the button status here
    // this.handleButtonStatus();
  }

}
